import { updateDatadogFeatureFlagAttributes } from "#lib/datadog.js";
import type { JwtPayload } from "#lib/jwt.js";
import { Logger } from "#lib/logging.js";
import type { Client } from "@optimizely/optimizely-sdk";

export function isFeatureEnabled(client: Client | null, flag: string, claims?: JwtPayload, attrs?: Record<string, string>): boolean {
	if (!client) {
		Logger.error("Optimizely client is not initialized");
		return false;
	}

	const attributes = {
		...attrs,
		orgId: claims?.tenantId ?? "",
		userEmail: claims?.email ?? "",
	};

	// Don't assume that the client is always configured with a valid datafile
	try {
		const isEnabled = client.isFeatureEnabled(flag, claims?.sub ?? "", attributes);
		updateDatadogFeatureFlagAttributes(flag, isEnabled);
		return isEnabled;
	} catch (error) {
		Logger.error("Error checking feature flag", { err: error });
		return false;
	}
}
